import { LOYALTY_API_BASE, LOYALTY_AUTH_HEADER } from "../constants";

/**
 * Wrapper around fetch() for the Loyalty Engine API.
 *
 * Automatically injects:
 *  - Authorization: Basic <token>  (from REACT_APP_LOYALTY_API_USERNAME/PASSWORD)
 *  - Any extra headers you provide
 *
 * Usage:
 *   loyaltyFetch(`${LOYALTY_API_BASE}/admin/loyalty-tiers?brand=foo`)
 *   loyaltyFetch(url, { method: "POST", body: JSON.stringify(payload), headers: { "X-Brand": brand } })
 *
 * @param {string} url       - Full URL (use LOYALTY_API_BASE + path)
 * @param {RequestInit} init - Standard fetch init options (method, headers, body, signal…)
 * @returns {Promise<Response>}
 */
export function loyaltyFetch(url, init = {}) {
    const { headers: extraHeaders = {}, ...rest } = init;
    return fetch(url, {
        ...rest,
        headers: {
            ...LOYALTY_AUTH_HEADER,
            ...extraHeaders,
        },
    });
}

export { LOYALTY_API_BASE };
